if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      let prodFormContainer = this;
      let prodForm = this.querySelector('form');
      let charMsg = document.querySelector('.char-msg');
      this.cartNotification = document.querySelector('cart-notification');
    
      let itemProperty = document.querySelector('#tinyDot');
    if(itemProperty != undefined) {
      let itemPropertyLimit = itemProperty.getAttribute('data-limit');
    }
      
      if (itemProperty != undefined) {
        let discButtons = document.querySelector('.product-form__input.Discs').querySelectorAll('label');
        const errorMsg = document.querySelector('.error-msg');
        itemProperty.addEventListener("keyup",function () {
          //document.querySelector('#tinyCount').innerHTML = this.value.length;
          if(this.value.length == 0) {
            charMsg.style.display = "block";
            prodForm.addEventListener("submit", function(evt) {
              evt.preventDefault();
            });
          } else if (this.value.length > discButtons.length){
            errorMsg.style.display = "block";
            this.value = this.value.substring(0, itemPropertyLimit);
            //prodForm.addEventListener('submit', prodFormContainer.onSubmitHandler.bind(prodFormContainer));
          } else {
            document.querySelector('.product-form__input.Discs').querySelector("[data-name='" + this.value.length + "']").click();
            errorMsg.style.display = "none";
            charMsg.style.display = "none";
            prodForm.addEventListener('submit', prodFormContainer.onSubmitHandler.bind(prodFormContainer));
          }
        });
      }

      if (itemProperty != undefined && itemProperty.value.length == 0) {
        prodForm.addEventListener("submit", function(evt) {
          charMsg.style.display = "block";
           evt.preventDefault();
        });
      } else {
        //charMsg.style.display = "none";
        prodForm.addEventListener('submit', prodFormContainer.onSubmitHandler.bind(prodFormContainer));
      }
    }

    onSubmitHandler(evt) {
//       evt.preventDefault();
//       this.cartNotification.setActiveElement(document.activeElement);

//       const submitButton = this.querySelector('[type="submit"]');

//       submitButton.setAttribute('disabled', true);
//       submitButton.classList.add('loading');

//       const body = JSON.stringify({
//         ...JSON.parse(serializeForm(this.form)),
//         sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
//         sections_url: window.location.pathname
//       });

//       fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
//         .then((response) => response.json())
//         .then((parsedState) => {
//           this.cartNotification.renderContents(parsedState);

//           var cartContents = fetch('/cart.js')
//           .then(response => response.json())
//           .then(data => {
//             console.log(data);
//             var shippingMin = 75;
//             var cartTotal = parseFloat(data.total_price/100);
//             var cartCalc = parseFloat(shippingMin - cartTotal).toFixed(2).replace('.00', '');

//             var totalPrice = document.querySelector('.totals__subtotal-value .money');
//             totalPrice.innerHTML = '$' + cartTotal.toFixed(2);

//             var announcementBar = document.querySelectorAll('.announcement-bar__message.free-shipping, .countdown-text');
//             for (var a = 0; a < announcementBar.length; a++){
//               if(cartTotal >= shippingMin) {
//                 announcementBar[a].innerText = 'You\'ve reached free shipping!';
//               } else {
//                 announcementBar[a].innerText = '$' + cartCalc + ' left for free shipping!';
//               }
//             }

//             var miniFooter = document.querySelector('.before-threshold');
//             var miniFooterAmount = miniFooter.querySelector('.add-amount');
//             if(cartTotal >= shippingMin) {
//               miniFooter.style.display = "none";
//             } else {
//               miniFooter.style.display = "inline";
//               miniFooterAmount.innerText = '$' + cartCalc;
//             }
//           });

//           console.log(parsedState);
//           if(parsedState.options_with_values.length > 0) {
//             var optionsContainer = '<dl>';
//             for(i=0; i < parsedState.options_with_values.length; i++) {
//               optionsContainer = optionsContainer + '<div class="product-option"><dt>' + parsedState.options_with_values[i].name +': </dt><dt>' + parsedState.options_with_values[i].value +'</dt></div>';
//             }
//             optionsContainer = optionsContainer + '</div>'
//           }

//           var tr = document.createElement('tr');
//           tr.classList.add('cart-item');
//           tr.innerHTML = `
//           <td class="cart-item__media">
//             <img class="cart-item__image" src="${parsedState.image}" alt="" loading="lazy" width="75" height="106">
//           </td>
//           <td class="cart-item__details">
//             <a href="${parsedState.url}" class="cart-item__name break">${parsedState.product_title}</a>
//             ${optionsContainer}
//             <p class="cart-item__error" id="Line-item-error-1">
//                 <span class="cart-item__error-text"></span>
//                 <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13">
//                   <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
//                   <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
//                   <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
//                   <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7">
//                   </path>
//                 </svg>
//             </p>
//             <quantity-input class="quantity">
//                 <button class="quantity__button no-js-hidden" name="minus" type="button">
//                   <span class="visually-hidden">Decrease quantity for ${parsedState.product_title}</span>
//                   <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
//                       <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
//                   </svg>
//                 </button>
//                 <input class="quantity__input" type="number" name="updates[]" value="${parsedState.quantity}" min="0" aria-label="Quantity for ${parsedState.product_title}" id="Quantity-1" data-index="1">
//                 <button class="quantity__button no-js-hidden" name="plus" type="button">
//                   <span class="visually-hidden">Increase quantity for ${parsedState.product_title}</span>
//                   <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
//                       <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
//                   </svg>
//                 </button>
//             </quantity-input>
//           </td>
//           <td class="cart-item__prices right">
//             <div class="cart-item__price-wrapper"><span class="price price--end">$${parsedState.final_price/100}</span>
//             </div>
//             <cart-remove-button id="Remove-1" data-index="1">
//                 <a href="/cart/change?id=${parsedState.key}&amp;quantity=0" class="button button--tertiary" aria-label="Remove ${parsedState.title}">
//                 Remove
//                 </a>
//             </cart-remove-button>
//           </td>
//           `;
//           var miniCart = document.querySelector('.mini-cart-container table.cart-items tbody');
//           if(miniCart === null) {
//             var miniCart = document.querySelector('.mini-cart-container');
//             var emptyMiniCart = document.querySelector('.mini-cart-container .js-contents');
//             var table = document.createElement('table');
//             table.classList.add('cart-items');
//             table.createTBody();
//             table.querySelector('tbody').append(tr);
//             emptyMiniCart.append(table);
//             emptyMiniCart.querySelector('.empty-cart').remove();
//             emptyMiniCart.querySelector('.continue-shopping-container').remove();
//             miniCart.classList.remove('empty');
//           } else {
//             var txa = miniCart.querySelector('.js-footer');
//             miniCart.insertBefore(tr, txa);
//           }

//         })
//         .catch((e) => {
//           console.error(e);
//         })
//         .finally(() => {
//           submitButton.classList.remove('loading');
//           submitButton.removeAttribute('disabled');
//         });
      
      if (document.querySelector('.mw-apo-container')) {
  document.querySelector('.product-form form').submit()
} else {
  evt.preventDefault();
  let body;
  let itemProperty = document.querySelector('#tinyDot');
  let chainProperty = document.querySelector('#chainLength');
  let prodForm = this.querySelector('form');
  this.cartNotification.setActiveElement(document.activeElement);

  const submitButton = this.querySelector('[type="submit"]');

  submitButton.setAttribute('disabled', true);
  submitButton.classList.add('loading');
  
  if (itemProperty != undefined) {
    let charMsg = document.querySelector('.char-msg');
    let errorMsg = document.querySelector('.error-msg');
    charMsg.style.display = "none";
    errorMsg.style.display = "none";
    body = JSON.stringify({
      properties: { Message: itemProperty.value },
      ...JSON.parse(serializeForm(prodForm)),
      sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });
  } else if (chainProperty != undefined) {
    body = JSON.stringify({
      properties: { 'Chain Length': chainProperty.value },
      ...JSON.parse(serializeForm(prodForm)),
      sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });
  } else {
    body = new FormData(prodForm);
    body.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
    body.append('sections_url', window.location.pathname);
    /*body = JSON.stringify({
      ...JSON.parse(serializeForm(prodForm)),
      sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });*/
  }

  fetch(`${routes.cart_add_url}.js`, { ...fetchConfig('form'), body })
    .then((response) => response.json())
    .then((parsedState) => {
      this.cartNotification.renderContents(parsedState);

      var cartContents = fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        var cartTotal = parseFloat(data.total_price/100);
        var cartCalc = parseFloat(shippingMin - cartTotal).toFixed(2).replace('.00', '');
        var totalPrice = document.querySelector('.totals__subtotal-value .money');
        totalPrice.innerHTML = '$' + cartTotal.toFixed(2);
        
        // added for gwp promo
        totalPrice.setAttribute('data-cart-total', cartTotal)
        if(gwpPromo){
          checkCart();
        }

        const announcementBars = document.querySelectorAll('.announcement-bar__message.free-shipping, .countdown-text');
        announcementBars.forEach(announcementBar => {
          if (cartTotal >= shippingMin) {
            announcementBar.innerText = thresholdMsgAchieved;
          } else {
            announcementBar.innerText = `$${cartCalc} ${thresholdMsgUntil}`;
          }
        });

        var miniFooter = document.querySelector('.before-threshold');
        var miniFooterAmount = miniFooter.querySelector('.add-amount');
        if(cartTotal >= shippingMin) {
          miniFooter.style.display = "none";
        } else {
          miniFooter.style.display = "inline";
          miniFooterAmount.innerText = '$' + cartCalc;
        }
      });

      if (parsedState.hasOwnProperty('items') && parsedState.items.length > 0) {
        parsedState.items.forEach((item) => {
          let bundleTimestamp = '';
          let isAddOn = false;
          let isPartOfBundle = false;
          var optionsContainer = '<div>';
          if(item.options_with_values.length > 0) {
            for(i=0; i < item.options_with_values.length; i++) {
              optionsContainer = optionsContainer + '<div class="product-option"><dt>' + item.options_with_values[i].name +': </dt><dt>' + item.options_with_values[i].value +'</dt></div>';
            };
          }
          if(item.properties != '') {
            for (let property in item.properties) {
              if (item.properties.hasOwnProperty(property)) {
                if (property == '_bundle_timestamp') {
                  bundleTimestamp = item.properties[property];
                  isPartOfBundle = true;
                }

                if (property == '_bundle_add_on') {
                  isAddOn = true;
                }

                if (!property.indexOf('_') == 0) {
                  optionsContainer = optionsContainer + '<div class="product-option"><dt>' + property +': </dt><dt>' + item.properties[property] +'</dt></div>';
                }
              }
              else {
                optionsContainer = optionsContainer + '';
              }
            }
            optionsContainer = optionsContainer + '</div>'
          }
          optionsContainer = optionsContainer + '</div>'

          var tr = document.createElement('tr');
          tr.classList.add('cart-item');

          let urlToRemove = `/cart/change?id=${item.key}&amp;quantity=0`;

          if (isPartOfBundle && !isAddOn) {
            urlToRemove = '/cart/update?';

            parsedState.items.forEach((item) => {
              if(item.properties != '') {
                for (let property in item.properties) {
                  if (item.properties.hasOwnProperty(property)) {
                    if (property == '_bundle_timestamp' && item.properties[property] == bundleTimestamp) {
                      if (urlToRemove == '/cart/update?') {
                        urlToRemove += `updates[${item.key}]=0`;
                      } else {
                        urlToRemove += `&updates[${item.key}]=0`;
                      }
                    }
                  }
                }
              }
            });
          }
            
          tr.innerHTML = `
          <td class="cart-item__media">
            <img class="cart-item__image" src="${item.image}" alt="" loading="lazy" width="75" height="106">
          </td>
          <td class="cart-item__details">
            <a href="${(isAddOn) ? '#' : item.url}" class="cart-item__name break">${item.product_title}</a>
            ${optionsContainer}
            <p class="cart-item__error" id="Line-item-error-1">
                <span class="cart-item__error-text"></span>
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13">
                  <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
                  <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
                  <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
                  <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7">
                  </path>
                </svg>
            </p>
            ${(isPartOfBundle) ? `<input class="quantity__input" type="number" name="updates[]" value="${item.quantity}" min="0" aria-label="Quantity for ${item.product_title}" id="Quantity-1" data-index="1" readonly>` : `<quantity-input class="quantity">
                <button class="quantity__button no-js-hidden" name="minus" type="button">
                  <span class="visually-hidden">Decrease quantity for ${item.product_title}</span>
                  <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
                  </svg>
                </button>
                <input class="quantity__input" type="number" name="updates[]" value="${item.quantity}" min="0" aria-label="Quantity for ${item.product_title}" id="Quantity-1" data-index="1">
                <button class="quantity__button no-js-hidden" name="plus" type="button">
                  <span class="visually-hidden">Increase quantity for ${item.product_title}</span>
                  <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
                  </svg>
                </button>
                </quantity-input>`}
          </td>
          <td class="cart-item__prices right">
            <div class="cart-item__price-wrapper"><span class="price price--end">${formatter.format(item.final_price/100)}</span>
            </div>
            <cart-remove-button id="Remove-1" data-index="1">
                <a href="${urlToRemove}" class="button button--tertiary" aria-label="Remove ${item.title}">
                Remove
                </a>
            </cart-remove-button>
          </td>
          `;
          var miniCart = document.querySelector('.mini-cart-container table.cart-items tbody');
          if(miniCart === null) {
            var miniCart = document.querySelector('.mini-cart-container');
            var emptyMiniCart = document.querySelector('.mini-cart-container .js-contents');
            var table = document.createElement('table');
            table.classList.add('cart-items');
            table.createTBody();
            table.querySelector('tbody').append(tr);
            emptyMiniCart.append(table);
            emptyMiniCart.querySelector('.empty-cart').remove();
            emptyMiniCart.querySelector('.continue-shopping-container').remove();
            miniCart.classList.remove('empty');
          } else {
            var removeBtns = document.querySelectorAll('cart-remove-button');
            var quantityInput = document.querySelectorAll('.quantity__input');
            for (var i = 0; i < removeBtns.length; ++i) {
              var newIndex = parseInt(removeBtns[i].dataset.index) + 1;
              removeBtns[i].setAttribute("data-index", newIndex);
              quantityInput[i].setAttribute("data-index", newIndex);
            }
            var txa = miniCart.querySelector('.js-footer');
            miniCart.prepend(tr);
          }
        });
      } else {
        var optionsContainer = '<div>';
        if(parsedState.options_with_values.length > 0) {
          for(i=0; i < parsedState.options_with_values.length; i++) {
            optionsContainer = optionsContainer + '<div class="product-option"><dt>' + parsedState.options_with_values[i].name +': </dt><dt>' + parsedState.options_with_values[i].value +'</dt></div>';
          };
        }
        if(parsedState.properties != '') {
          for (let property in parsedState.properties) {
            if (parsedState.properties.hasOwnProperty(property)) {
              optionsContainer = optionsContainer + '<div class="product-option"><dt>' + property +': </dt><dt>' + parsedState.properties[property] +'</dt></div>';
            }
            else {
              optionsContainer = optionsContainer + '';
            }
          }
          optionsContainer = optionsContainer + '</div>'
        }
        optionsContainer = optionsContainer + '</div>'

        var tr = document.createElement('tr');
        tr.classList.add('cart-item');
        tr.innerHTML = `
        <td class="cart-item__media">
          <img class="cart-item__image" src="${parsedState.image}" alt="" loading="lazy" width="75" height="106">
        </td>
        <td class="cart-item__details">
          <a href="${parsedState.url}" class="cart-item__name break">${parsedState.product_title}</a>
          ${optionsContainer}
          <p class="cart-item__error" id="Line-item-error-1">
              <span class="cart-item__error-text"></span>
              <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13">
                <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
                <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
                <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
                <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7">
                </path>
              </svg>
          </p>
          <quantity-input class="quantity">
              <button class="quantity__button no-js-hidden" name="minus" type="button">
                <span class="visually-hidden">Decrease quantity for ${parsedState.product_title}</span>
                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
                </svg>
              </button>
              <input class="quantity__input" type="number" name="updates[]" value="${parsedState.quantity}" min="0" aria-label="Quantity for ${parsedState.product_title}" id="Quantity-1" data-index="1">
              <button class="quantity__button no-js-hidden" name="plus" type="button">
                <span class="visually-hidden">Increase quantity for ${parsedState.product_title}</span>
                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
                </svg>
              </button>
          </quantity-input>
        </td>
        <td class="cart-item__prices right">
          <div class="cart-item__price-wrapper"><span class="price price--end">${formatter.format(parsedState.final_price/100)}</span>
          </div>
          <cart-remove-button id="Remove-1" data-index="1">
              <a href="/cart/change?id=${parsedState.key}&amp;quantity=0" class="button button--tertiary" aria-label="Remove ${parsedState.title}">
              Remove
              </a>
          </cart-remove-button>
        </td>
        `;
        var miniCart = document.querySelector('.mini-cart-container table.cart-items tbody');
        if(miniCart === null) {
          var miniCart = document.querySelector('.mini-cart-container');
          var emptyMiniCart = document.querySelector('.mini-cart-container .js-contents');
          var table = document.createElement('table');
          table.classList.add('cart-items');
          table.createTBody();
          table.querySelector('tbody').append(tr);
          emptyMiniCart.append(table);
          emptyMiniCart.querySelector('.empty-cart').remove();
          emptyMiniCart.querySelector('.continue-shopping-container').remove();
          miniCart.classList.remove('empty');
        } else {
          var removeBtns = document.querySelectorAll('cart-remove-button');
          var quantityInput = document.querySelectorAll('.quantity__input');
          for (var i = 0; i < removeBtns.length; ++i) {
            var newIndex = parseInt(removeBtns[i].dataset.index) + 1;
            removeBtns[i].setAttribute("data-index", newIndex);
            quantityInput[i].setAttribute("data-index", newIndex);
          }
          var txa = miniCart.querySelector('.js-footer');
          miniCart.prepend(tr);
        }
      }

    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('disabled');
    });
}
    }
  });
}